import { useEffect } from "react";
import moment from "moment";
import useStorage from "./useStorage";
import Config from "../config";
import { message } from "antd";
import { getCurrentDate, getCurrentTime } from "../API";
import { toNumber } from "../pages/homework/utils/filter";
import { atom, useAtom } from "jotai";

const timeAtom = atom({
    time: moment(), // 浏览器时间
    offset: 0, // 浏览器与服务器偏移
    synced: false, // 是否已经同步服务器时间
    batchName: "",
    theWeek: "1",
    batchNo: "",
    endDate: "",
    startDate: moment().format("YYYY-MM-DD")
});

let isLoading = false;

/**
 *
 * @param sync // 是否持续刷新时间
 */
export default function useCurrentDate() {
    const [batch] = useStorage(
        "batch",
        localStorage.getItem("batch") || Config.DefaultBatch
    );
    const [data, setTime] = useAtom(timeAtom);

    useEffect(() => {
        if (!data.synced) syncFromServer();
    }, [batch]);

    async function syncFromServer() {
        if (isLoading) return;

        isLoading = true;

        try {
            const resDatePromise = getCurrentDate();
            const resTimePromise = getCurrentTime();
            const resDate = await resDatePromise;
            const resTime = await resTimePromise;

            const serverTime = moment(resTime.dateTime);
            const browserTime = moment();
            const offset = serverTime.diff(browserTime);
            const theWeek = Math.min(
                toNumber(resDate.theWeek),
                Config.MaxWeek
            ).toString();

            setTime({
                ...resDate,
                time: browserTime,
                offset,
                theWeek,
                synced: true
            });
        } catch (e) {
            message.warn("无法获取当前学期信息");
        } finally {
            isLoading = false;
        }
    }

    return { ...data, time: data.time.add(data.offset), syncFromServer };
}
